// extracted by css-extract-rspack-plugin
export default {"suggestionPaper":"NGe6a"};